import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    super.connect();
    this._resize();
    this.resizeHanler = this._onInput.bind(this);
    this.element.addEventListener('input', this.resizeHanler);
  }

  disconnect() {
    super.disconnect();
    this.element.removeEventListener('input', this.resizeHanler)
  }

  _onInput() {
    this._resize();
  }

  _resize() {
    this.element.style.height = "auto";
    this.element.style.height = this.element.scrollHeight + "px";
  }
}